/**
 * @module app.prospection.store.callsCtrl
 */
function CallsCtrl($scope, callsService, $root, Notification, $uibModal) {
    let self = this;
    let currentAudio = null;
    self.store = $scope.storeCtrl.store;
    self.to = new Date();
    self.from = new Date();
    self.from.setMonth(self.from.getMonth() - 1);

    self.isOpenFrom = false;
    self.isOpenTo = false;

    self.isLoading = false;
    self.error = {};
    self.playingRecording = null;

    self.reasons = {
        out_of_opening_hours: 'En dehors des horaires d\'ouverture',
        short_abandoned: 'Abandon',
        abandoned_in_ivr: 'Abandon dans l\'IVR',
        abandoned_in_classic: 'Abandon',
        no_available_agent: 'Aucun agent disponible',
        agents_did_not_answer: 'L\'agent n\'a pas répondu'
    };


    // Get GLPI store's tickets
    self.getCalls = function () {
        _stopRecording();
        self.error = {};
        self.isLoading = true;
        self.store.calls = [];
        let from = _formatDate(self.from);
        let to = _formatDate(self.to);
        if(self.store.contact.telephone_fixe.trim() !== '')
            callsService
                .getCalls((self.store.contact.telephone_fixe).replace(/^0/, '+33'), from, to)
                .then(function (calls) {
                    self.store.calls = self.store.calls.concat(calls);
                    self.store.calls.sort(function (a, b) {
                        return Number(b.started_at) - Number(a.started_at);
                    });
                }).catch(function (err) {
                self.error = {
                    error: true,
                    class: 'alert-danger',
                    message:
                        'Une erreur est survenue' +
                        (err.statusText ? ' : [' + err.status + '] ' + err.statusText + ' - ' + err.data : '')
                };
            });
        if(self.store.contact.telephone_portable.trim() !== '' && self.store.contact.telephone_portable.trim() !== self.store.contact.telephone_fixe.trim())
            callsService.getCalls((self.store.contact.telephone_portable).replace(/^0/, '+33'), from, to)
            .then(function (calls) {
                self.store.calls = self.store.calls.concat(calls); self.store.calls.sort(function (a, b) {
                    return Number(b.started_at) - Number(a.started_at);
                });
            })
            .catch(function (err) {
                self.error = {
                    error: true,
                    class: 'alert-danger',
                    message:
                        'Une erreur est survenue' +
                        (err.statusText ? ' : [' + err.status + '] ' + err.statusText + ' - ' + err.data : '')
                };

            });
        self.isLoading = false;
    };

    self.toggleFrom = function() {
        self.isOpenFrom = !self.isOpenFrom;
    };

    self.toggleTo = function() {
        self.isOpenTo = !self.isOpenTo;
    };

    function _formatDate(date) {
        if (!date) {
            return '';
        }

        let d = new Date(date);
        return Math.floor(d.getTime() / 1000);
    }

    self.formatUnixDate = function (unixTs) {
        if (unixTs === null || unixTs === undefined || unixTs === '') {
            return '';
        }

        let ts = Number(unixTs);
        if (Number.isNaN(ts)) {
            return '';
        }

        // Si timestamp en secondes, on le convertit en millisecondes
        if (ts < 1e12) {
            ts = ts * 1000;
        }

        const d = new Date(ts);
        if (Number.isNaN(d.getTime())) {
            return '';
        }

        const pad = (n) => String(n).padStart(2, '0');

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    self.formatDuration = function (startTs, endTs) {
        if (startTs === null || startTs === undefined || startTs === '' ||
            endTs === null || endTs === undefined || endTs === '') {
            return '';
        }

        let start = Number(startTs);
        let end = Number(endTs);

        if (Number.isNaN(start) || Number.isNaN(end)) {
            return '';
        }

        // Convertir en secondes si les timestamps sont en millisecondes
        if (start > 1e12) {
            start = Math.floor(start / 1000);
        }
        if (end > 1e12) {
            end = Math.floor(end / 1000);
        }

        // Calculer la différence en secondes (valeur absolue)
        let diffSeconds = Math.abs(end - start);

        // Formatter le résultat
        if (diffSeconds < 60) {
            return `${diffSeconds}s`;
        } else {
            const minutes = Math.floor(diffSeconds / 60);
            const seconds = diffSeconds % 60;
            return `${minutes}min ${seconds}s`;
        }
    };

    self.toggleRecording = function (recordingUrl) {
        if (!recordingUrl) {
            return;
        }

        if (self.playingRecording === recordingUrl) {
            _stopRecording();
            return;
        }

        _playRecording(recordingUrl);
    };

    self.isRecording = function (recordingUrl) {
        return !!recordingUrl && self.playingRecording === recordingUrl;
    };

    self.prepareSummary = function(call) {
        self.callToOpen = call;
        _openModalCallSummary('lg');
    };

    function _openModalCallSummary(size) {
        $uibModal.open({
            animation: true,
            templateUrl: 'callSummary.html',
            controller: 'CallSummaryCtrl',
            controllerAs: 'callSummaryCtrl',
            size: size,
            resolve: {
                call: function() {
                    return self.callToOpen
                }
            }
        });
    }

    function _setPlayingRecording(recordingUrl) {
        $scope.$evalAsync(function () {
            self.playingRecording = recordingUrl || null;
        });
    }

    function _detachAudioListeners(audio) {
        if (!audio) {
            return;
        }

        audio.onended = null;
        audio.onerror = null;
    }

    function _stopRecording() {
        if (!currentAudio) {
            _setPlayingRecording(null);
            return;
        }

        _detachAudioListeners(currentAudio);
        currentAudio.pause();

        try {
            currentAudio.currentTime = 0;
        } catch (e) {
        }

        currentAudio = null;
        _setPlayingRecording(null);
    }

    function _handleAudioEnded(audio) {
        if (currentAudio !== audio) {
            return;
        }

        _stopRecording();
    }

    function _handleAudioError(audio) {
        if (currentAudio !== audio) {
            return;
        }

        _stopRecording();
        Notification.error('Impossible de lire l\'enregistrement audio.');
    }

    function _playRecording(recordingUrl) {
        let audio;
        let playPromise;

        _stopRecording();

        audio = new window.Audio(recordingUrl);
        currentAudio = audio;
        audio.onended = function () {
            _handleAudioEnded(audio);
        };
        audio.onerror = function () {
            _handleAudioError(audio);
        };
        _setPlayingRecording(recordingUrl);

        playPromise = audio.play();

        if (playPromise && typeof playPromise.catch === 'function') {

            playPromise.catch(function () {
                _handleAudioError(audio);
            });
        }
    }

    function _offline() {
        _stopRecording();
        self.error = {
            error: true,
            message: 'Vous ne pouvez pas accéder aux appels en mode hors ligne'
        };
    }

    function _online() {
        _stopRecording();
        self.store.calls = [];
        self.error = {};
    }

    if ($root.online) {
        _online();
    }
    else {
        _offline();
    }

    let unbindOnline = $root.$on('online', _online);

    let unbindOffline = $root.$on('offline', _offline);

    $scope.$on('$destroy', function () {
        _stopRecording();
        unbindOnline();
        unbindOffline();
    });
}

CallsCtrl.$inject = ['$scope', 'callsService', '$rootScope', 'Notification', '$uibModal'];

angular.module('app.prospection.store.callsCtrl', []).controller('CallsCtrl', CallsCtrl);
